import { IStop } from '@clean-code/types/stops';
import type { WorkflowOrigin } from '@clean-code/analytics/workflow';

export const SHOW_ANNOTATE_STOP_ERROR_MODAL = 'SHOW_ANNOTATE_STOP_ERROR_MODAL';
export const HIDE_ANNOTATE_STOP_ERROR_MODAL = 'HIDE_ANNOTATE_STOP_ERROR_MODAL';

export interface AnnotateStopErrorModalData {
  stopInfo: IStop;
  error: Error;
  /** Page the overwritten annotation came from, for analytics. */
  origin?: WorkflowOrigin;
  trackSuccess?: boolean;
}

export interface ModalState {
  annotateStopErrorModal: {
    isOpen: boolean;
    data: AnnotateStopErrorModalData | null;
  };
}
